// extracted by css-extract-rspack-plugin
export default {"highlightedText":"SearchMatchText-module__highlightedText__ATaD0"};